"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Link_1 = require("../Link");
const SettingsProvider_1 = require("../../settings/SettingsProvider");
const hooks_1 = require("../../hooks");
const Row_1 = require("../Row");
const Footer_module_css_1 = __importDefault(require("./Footer.module.css"));
const a = (children) => (react_1.default.createElement(Link_1.Link, { href: "https://www.lemonone.com/", target: "_blank", rel: "noopener noreferrer" }, children));
const Footer = ({ children }) => {
    var _a, _b, _c;
    const intl = hooks_1.useIntlScope('@lemonone/intl/text:');
    const tpl = hooks_1.useIntlScope('@lemonone/components/Footer:');
    const settings = SettingsProvider_1.useSettings();
    return (react_1.default.createElement(Row_1.Row, { className: classnames_1.default(Footer_module_css_1.default.block) },
        children && react_1.default.createElement("div", { className: Footer_module_css_1.default.row }, children),
        react_1.default.createElement("div", { className: Footer_module_css_1.default.row },
            react_1.default.createElement("div", { className: Footer_module_css_1.default.hr })),
        react_1.default.createElement("div", { className: classnames_1.default(Footer_module_css_1.default.links, Footer_module_css_1.default.row) },
            react_1.default.createElement("div", { className: Footer_module_css_1.default.link },
                react_1.default.createElement(Link_1.Link, { color: "primary", rel: "noopener noreferrer", href: (_a = intl('termsAndConditionsUrl')) === null || _a === void 0 ? void 0 : _a.toString(), target: "_blank" }, intl('termsAndConditions'))),
            react_1.default.createElement("div", { className: Footer_module_css_1.default.link },
                react_1.default.createElement(Link_1.Link, { color: "primary", rel: "noopener noreferrer", href: (_b = intl('privacyPolicyUrl')) === null || _b === void 0 ? void 0 : _b.toString(), target: "_blank" }, intl('privacyPolicy')))),
        react_1.default.createElement("div", { className: Footer_module_css_1.default.row }, ((_c = settings === null || settings === void 0 ? void 0 : settings.emails) === null || _c === void 0 ? void 0 : _c.sentOnBehalf)
            ? tpl('white-label:info', { a, name: settings.emails.sentOnBehalf }) //
            : tpl('info', { a }))));
};
exports.Footer = Footer;
//# sourceMappingURL=Footer.js.map